import { DOCUMENT_PUBLICATION_STATUS } from 'api/documents/documents.model';

export const isPublicationInProgress = (documentPublicationStatus: DOCUMENT_PUBLICATION_STATUS) =>
  [
    DOCUMENT_PUBLICATION_STATUS.PREPARED_TO_SIGN,
    DOCUMENT_PUBLICATION_STATUS.PUBLISHING_INITIATED,
  ].includes(documentPublicationStatus);
